import axios from "axios";
import api, { callRefreshToken } from "../config/http-common";

// export const getAllProjectReports= async ()=>{
//     return api.securedAxios().get("/timesheet/projectreport")
// }

export const getAllProjectReports = async (startTime, endTime) => {
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get("/report/project");
};

export const getProjectReportById = async (payload) => {
  let url = "//timesheet/projectreport";
  if (payload?.toggleKeyToURL) {
    url += "&toggleKeyToURL=true";
  }
  if (payload?.id) {
    url += `&id=${payload.id}`;
  }
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const getProjectMembers = async (projectId) => {
  const url = `/report/project/members?projectId=${projectId}`;
  const value = await callRefreshToken();
  if (value == true)
    return await api.securedAxios().get(url);
};

export const exportProjectReport = async (
  projects,
  clientId,
  member,
  startDate,
  endDate,
  tags,
  includeMemberContribution
) => {
  try {
    const requestBody = {
      projects: Array.isArray(projects) ? projects : projects ? [projects] : [],
      clientId: clientId || null,
      member: member || null,
      startDate: startDate || null,
      endDate: endDate || null,
      tags: Array.isArray(tags) ? tags : tags ? [tags] : [],
      includeMemberContribution: !!includeMemberContribution,
    };

    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + "/reports/project/export",
        requestBody,
        {
          responseType: "blob", // Important to specify the response type as blob
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      let projectName = "Project_reports";
      if (includeMemberContribution) {
        projectName += "_with_member_contribution";
      }

      // Create a link element and trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${projectName}.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the file", error);
  }
};


export const exportTaskReport = async (
  projects,
  member,
  startDate,
  endDate
) => {
  try {
    const requestBody = {
      projects: Array.isArray(projects) ? projects : projects ? [projects] : [],
      member: member || null,
      startDate: startDate || null,
      endDate: endDate || null,
    };

    const value = await callRefreshToken();
    if (value === true) {
      const response = await axios.post(
        process.env.REACT_APP_SERVER_URL?.replace("/web", "/api/v1") + "/reports/tasks/export",
        requestBody,
        {
          responseType: "blob", // Important to specify the response type as blob
          headers: {
            Authorization: localStorage.getItem("token"),
            timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        }
      );

      const fileName = "Task_reports.xlsx";
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.error("Error downloading the task report", error);
  }
};


